import { RequestInfo, ResponseOptions, STATUS } from 'angular-in-memory-web-api';
import { Injectable } from '@angular/core';
import { InMemoryHttpClient } from './in-memory-http-client';
import { Observable } from 'rxjs';
import { Authority } from '../../../classes/enums/Authority';
import { AuthResponse } from '../../../interfaces/response/AuthResponse';

/**
 * This service intercepts {@link AuthService} requests and redirects them to an in-memory data store.
 */
@Injectable({
  providedIn: 'root',
})
export class InMemoryAuthDataService implements InMemoryHttpClient {

  /** Current user test data. */
  public currentUser: AuthResponse = {
    jwtToken: 'token',
    authorities: Object.values(Authority)
  };

  /**
   * Intercepts HTTP GET request of {@link AuthService}.
   * @param reqInfo information about the current HTTP GET request.
   */
  get(reqInfo: RequestInfo) {
    return undefined;
  }

  /**
   * Intercepts HTTP DELETE request of {@link AuthService}.
   * @param reqInfo information about the current HTTP DELETE request.
   */
  delete(reqInfo: RequestInfo): Observable<ResponseOptions> {
    return undefined;
  }

  /**
   * Intercepts HTTP POST request of {@link AuthService}. Returns current user test data as authentication response.
   * @param reqInfo information about the current HTTP POST request.
   */
  post(reqInfo: RequestInfo): Observable<ResponseOptions> {
    return reqInfo.utils.createResponse$(() => {
      return this.login();
    });
  }

  /**
   * Intercepts HTTP PUT request of {@link AuthService}.
   * @param reqInfo information about the current HTTP PUT request.
   */
  put(reqInfo: RequestInfo): Observable<ResponseOptions> {
    return undefined;
  }

  private login(): ResponseOptions {
    return {
      body: this.currentUser,
      status: STATUS.OK,
    };
  }

  /**
   * Intercepts HTTP PATCH request of {@link AuthService}.
   * @param reqInfo information about the current HTTP PATCH request.
   */
  patch(reqInfo: RequestInfo): Observable<ResponseOptions> {
    return undefined;
  }
}
